'use strict';

angular.module(ApplicationConfiguration.applicationModuleName).factory('Auth', ['$resource', '$stateParams', 'apiSettings', function ($resource, $stateParams, apiSettings) {
	return $resource(null, { id: '@id' }, {
		signin: {
			url: apiSettings.baseUri + 'v1/auth/signin',
			method: 'POST'
		},
		validateToken: {
			url: apiSettings.baseUri + 'v1/auth/validate-password-reset-token',
			method: 'POST'
		},
		forgotPassword: {
			url: apiSettings.baseUri + 'v1/auth/forgot-password',
			method: 'POST'
		},
		passwordReset: {
			url: apiSettings.baseUri + 'v1/auth/password-reset',
			method: 'POST'
		},
		passwordResetRandom: {
			url: apiSettings.baseUri + 'v1/auth/password-reset-random',
			method: 'POST'
		},
		passwordChange: {
			url: apiSettings.baseUri + 'v1/auth/password-change',
			method: 'POST'
		},
		refreshFcmToken: {
			url: apiSettings.baseUri + 'v1/auth/fcm-token',
			method: 'POST'
		},
		logout: {
			url: apiSettings.baseUri + 'v1/auth/logout',
			method: 'POST'
		}		
	});
}]);